import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class UserResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  update(data, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .patch(data, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
